module.exports = __webpack_public_path__ + "img/score_right.b2903b40.png";